/* global common, L */
import { getCdnUrl } from '@html/_common/utils';

/* Colorful map */
export default function DynamicMap() {
  let destinationIcon;
  let startIcon;
  let endIcon;
  let wayIcon;

  let map;
  let animatedMarker;

  let markers;

  const TILE_LAYER = 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}?access_token=';
  const SPEED = 8000;
  this.common = typeof getCdnUrl !== 'undefined' ? { getCdnUrl } : common;

  this.map = (divId, token) => {
    const parameters = {
      scrollWheelZoom: true,
      dragging: true,
    };

    map = L.map(divId, parameters);
    L.tileLayer(TILE_LAYER + token, {
      attribution:
        '&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      tileSize: 512,
      zoomOffset: -1,
    }).addTo(map);
    return map;
  };

  this.showPopup = (id) => {
    if (!markers) {
      return;
    }

    markers[id].togglePopup();
  };

  this.addLocations = (locations) => {
    /** initialize icons * */
    destinationIcon = L.icon({
      iconUrl: `${this.common.getCdnUrl()}images/responsive/tour/destination-map-new.svg`,
      iconSize: [10, 10],
      iconAnchor: [5, 5],
      popupAnchor: [0, -10],
    });
    startIcon = L.icon({
      iconUrl: `${this.common.getCdnUrl()}images/responsive/tour/start-map-new.svg`,
      iconSize: [24, 24],
      iconAnchor: [12, 12],
      popupAnchor: [0, -15],
    });
    endIcon = L.icon({
      iconUrl: `${this.common.getCdnUrl()}images/responsive/tour/end-map-new.svg`,
      iconSize: [24, 24],
      iconAnchor: [12, 12],
      popupAnchor: [0, -15],
    });
    wayIcon = L.icon({
      iconUrl: `${this.common.getCdnUrl()}images/responsive/tour/runner-new.svg?v=1`,
      iconSize: [14, 14],
      iconAnchor: [7, 7],
    });

    // Add markers
    const polyline = [];
    markers = [];
    locations.forEach((location, index) => {
      /* eslint-disable */
      if (!isNaN(parseFloat(location.city_x)) && !isNaN(parseFloat(location.city_y))) {
      /* eslint-enable */
        const cityPosition = [
          parseFloat(location.city_x),
          parseFloat(location.city_y),
        ];
        let icon = destinationIcon;
        if (index === 0) {
          icon = startIcon;
        }
        if (index === locations.length - 1) {
          icon = endIcon;
        }
        const marker = L.marker(cityPosition, {
          icon,
        }).addTo(map);
        polyline.push(cityPosition);
        marker.bindPopup(`${location.city_name}, ${location.country_name}`);
        markers[location.city_id] = marker;
      }
    });

    // Fit markers to map
    if (locations.length === 1) {
      map.setView(
        L.latLng(
          parseFloat(locations[0].city_x),
          parseFloat(locations[0].city_y),
        ),
        locations[0].city_zoom,
      );
    } else {
      map.fitBounds(polyline, {
        padding: [20, 20],
      });
    }

    // Add connecting lines
    L.polyline(polyline, {
      color: '#0A7BBD',
      weight: 3,
      opacity: 1.0,
    }).addTo(map);

    if (locations.length > 1) {
      // Animate marker on polyline
      animatedMarker = L.Marker.movingMarker(polyline, SPEED, {
        autostart: true,
        loop: true,
        icon: wayIcon,
      }).addTo(map);

      map.on('zoomstart', () => {
        animatedMarker.pause();
      });

      map.on('zoomend', () => {
        animatedMarker.resume();
      });
    }
  };

  this.animatedMarker = () => animatedMarker;
}
